// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { xIsAuthenticated } from "@werner/App/Store/Selectors/GeneralSelectors";
import { getSettingsCollection } from "@werner/App/Store/Selectors/SettingsSelectors";
import { hideElementOnPrint } from "@werner/XDL/Utilities";
import React, { useEffect } from "react";

const Chat = () => {
    const { chatSettings, isAuthenticated, chatEnabled } = useAppSelector(state => {
        return {
            chatSettings: getSettingsCollection(state).chatSettings,
            isAuthenticated: xIsAuthenticated(state),
            chatEnabled: getSettingsCollection(state).customSettings.enableChat,
        };
    });
    useEffect(() => {
        if (isAuthenticated && chatEnabled) {
            const s = document.createElement("script");
            s.type = "text/javascript";
            const code = `
                window.lhnJsSdkInit = function () {
                    lhnJsSdk.setup = {
                        application_id: '${chatSettings.applicationId}',
                        application_secret: '${chatSettings.applicationSecret}'
                    };
                    lhnJsSdk.controls = [{
                        type: '${chatSettings.controlsType}',
                        id: '${chatSettings.controlsId}'
                    }];
                };
                (function (d, s) {
                    var newjs, lhnjs = d.getElementsByTagName(s)[0];
                    newjs = d.createElement(s);
                    newjs.src = '${chatSettings.chatSource}';
                    lhnjs.parentNode.insertBefore(newjs, lhnjs);
                }(document, "script"));
                `;

            // XNG-Change: changed zIndex so its below modals and on top of drawers
            const style = `
            div#lhnHocButton.lhnslide {
                    z-index: 1283; 
                    ${hideElementOnPrint}
                }
                `;
            const chatStyleSheet = document.createElement("style");
            chatStyleSheet.innerHTML = style;
            try {
                s.appendChild(document.createTextNode(code));
                document.head.appendChild(chatStyleSheet);
                document.body.appendChild(s);
            } catch (e) {
                s.text = code;
                document.body.appendChild(s);
            }
        }
    }, [chatSettings.chatSource]);

    return null;
};

export default Chat;
